export const characterList2PresentationStart = {
  transform: 'translate(calc(50vw + 100%), -50%) rotate(8deg)',
  opacity: 0
};

// Reveal copies never participate in Turbo, automation, or the character roster.
export function createCharacterList2Presentation(character, container) {
  const overlay = document.createElement('div');
  overlay.id = `presentation_2_${character.id}`;
  overlay.dataset.turboPermanent = '';
  overlay.className = 'character-list-2__presentation is-active';
  overlay.setAttribute('aria-hidden', 'true');
  overlay.inert = true;
  overlay.setAttribute('popover', 'manual');
  // showPopover exposes the top layer immediately. Seed the same entrance pose
  // before opening so startup work can never reveal the centered base CSS pose.
  Object.assign(overlay.style, characterList2PresentationStart);
  const card = character.querySelector('.character-list-2__card').cloneNode(true);
  for (const element of [card, ...card.querySelectorAll('*')]) {
    const iconUrl = element.getAttribute('data-condition-icon-url-value');
    const title = element.getAttribute('data-bs-original-title');
    if (title) element.setAttribute('title', title);
    for (const attribute of [...element.attributes]) {
      if (attribute.name === 'id' || attribute.name.startsWith('data-') ||
          ['aria-describedby', 'aria-labelledby', 'aria-current', 'tabindex'].includes(attribute.name)) {
        element.removeAttribute(attribute.name);
      }
    }
    // Copies may be made before the source's asynchronous SVG load finishes.
    if (iconUrl) {
      element.setAttribute('data-controller', 'condition-icon');
      element.setAttribute('data-condition-icon-url-value', iconUrl);
    }
  }
  // A source can carry focus positioning; the top-layer copy starts upright.
  for (const property of ['translate', 'scale', 'transition', 'z-index']) card.style.removeProperty(property);
  card.style.transform = 'none';
  overlay.append(card);
  container.append(overlay);
  overlay.showPopover();
  return overlay;
}
